export default "__VITE_ASSET__Bx5Zp7Ux__"